// extracted by mini-css-extract-plugin
export var headerCell = "_46-1";
export var loadingSpinnerContainer = "_46-4";
export var rowWrapper = "_46-3";
export var standaloneTable = "_46-5";
export var table = "_46-0";
export var white = "_46-2";